/**!
 * Created by Leonardo Cheslacki on 06/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import AnimateController from './../AnimateController';

let _this = {};

/**
 *
 */
class StudentController extends AnimateController {
    /**
     *
     */
    constructor() {
        super();
        _this = this;
    };

    $functionsStudent = {
        /**
         *
         * @param event
         * @param reference
         */
        handleLoadedMetadataAudio: function (event, {reference}) {
            _this.removeListener('loadedmetadata', reference, _this.$functionsStudent.handleLoadedMetadataAudio);
        },

        /**
         *
         * @param event
         * @param reference
         * @param callback
         */
        handleLoadedDataAudio: function (event, {reference, callback}) {
            const {element} = _this.state;

            _this.removeListener('loadeddata', reference, _this.$functionsStudent.handleLoadedDataAudio);

            (typeof (callback) === 'function') && callback({duration: element.duration});
        },

        /**
         *
         * @param event
         * @param reference
         */
        handleLoadedMetadataVideo: function (event, {reference}) {
            const {element} = _this.state;

            element.currentTime = 5;

            _this.removeListener('loadedmetadata', reference, _this.$functionsStudent.handleLoadedMetadataVideo);
        },

        /**
         *
         * @param event
         * @param reference
         * @param width
         * @param height
         * @param callback
         */
        handleLoadedDataVideo: function (event, {reference, width, height, callback}) {
            const
                {element} = _this.state,
                buffer = (new createjs.VideoBuffer(element)),
                bitmap = (new createjs.Bitmap(buffer));

            bitmap.scaleX = _this.calcSize(buffer._video.videoWidth, width + 30, bitmap.scaleX);
            bitmap.scaleY = _this.calcSize(buffer._video.videoHeight, height + 16.9, bitmap.scaleY);

            _this.removeListener('loadeddata', reference, _this.$functionsStudent.handleLoadedDataVideo);

            (typeof (callback) === 'function') && callback({duration: element.duration, thumbnail: bitmap});
        }
    };

    /**
     *
     * @param data
     * @param _id
     * @returns {*}
     */
    findDataId = (data, _id) => {
        return data.find(({attachment: {id}}) => (id === _id));
    };

    closeFile = () => {
        const
            {element} = this.state,
            app = document.getElementById('app');

        this.isElement(element) && app.removeChild(element);

        this.setState({...this.state, element: null});
    };

    /**
     *
     * @param uri
     */
    openFile = (uri) => {
        const app = document.getElementById('app');

        this.closeFile();

        this.setState({...this.state, element: document.createElement('embed')}, ({element}) => {
            element.style.position = 'absolute';
            element.style.top = '0';
            element.style.width = '100%';
            element.style.height = '100%';
            element.src = uri;
            app.appendChild(element);
        });
    };

    /**
     *
     * @param uri
     * @param callback
     */
    getAudioMetadata = (uri, callback) => {
        const
            type_loadedmetadata = 'loadedmetadata',
            reference_loadedmetadata = 'loadedmetadata-audio',
            type_loadeddata = 'loadeddata',
            reference_loadeddata = 'loadeddata-audio';

        this.setState({...this.state, element: document.createElement('audio')}, ({element}) => {
            this.removeListener(type_loadedmetadata, reference_loadedmetadata, this.$functionsStudent.handleLoadedMetadataAudio, () => {
                this.addListener(element, type_loadedmetadata, reference_loadedmetadata, this.$functionsStudent.handleLoadedMetadataAudio, false, {
                    reference: reference_loadedmetadata
                });
            });

            this.removeListener(type_loadeddata, reference_loadeddata, this.$functionsStudent.handleLoadedDataAudio, () => {
                this.addListener(element, type_loadeddata, reference_loadeddata, this.$functionsStudent.handleLoadedDataAudio, false, {
                    reference: reference_loadeddata,
                    callback: callback
                });
            });

            element.src = uri;
        });
    };

    /**
     *
     * @param uri
     * @param occurrence
     * @param width
     * @param height
     * @param callback
     */
    getVideoMetadata = (uri, occurrence, width, height, callback) => {
        const
            type_loadedmetadata = 'loadedmetadata',
            reference_loadedmetadata = `loadedmetadata-video-${occurrence}`,
            type_loadeddata = 'loadeddata',
            reference_loadeddata = `loadeddata-video-${occurrence}`;

        this.setState({...this.state, element: document.createElement('video')}, ({element}) => {
            this.removeListener(type_loadedmetadata, reference_loadedmetadata, this.$functionsStudent.handleLoadedMetadataVideo, () => {
                this.addListener(element, type_loadedmetadata, reference_loadedmetadata, this.$functionsStudent.handleLoadedMetadataVideo, false, {
                    reference: reference_loadedmetadata
                });
            });

            this.removeListener(type_loadeddata, reference_loadeddata, this.$functionsStudent.handleLoadedDataVideo, () => {
                this.addListener(element, type_loadeddata, reference_loadeddata, this.$functionsStudent.handleLoadedDataVideo, false, {
                    reference: reference_loadeddata,
                    width: width,
                    height: height,
                    callback: callback
                });
            });

            element.src = uri;
        });
    };
}

export default StudentController;
